// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import GridApi, {getDefaultState as getGridApiDefaultState} from './grid-api';
import Metric, {getDefaultState as getMetricDefaultState} from './metric';
import OpenPipProgramsReport, {getDefaultState as getOpenPipProgramsReportDefaultState} from './report';
import PipStatuses, {getDefaultState as getOpenPipProgramsStatusesDefaultState} from './pip-statuses';
import ReportIsScrollable, {getDefaultState as getReportIsScrollableDefaultState} from '../../shared/state/report-is-scrollable';
import SelectedDealers, {getDefaultState as getSelectedDealersDefaultState} from './selected-dealers';
import t from 'tcomb';

const OpenPipReport = t.struct({
    busyCounter: BusyCounter,
    gridApi: GridApi,
    includeFullyComplete: t.Boolean,
    metric: Metric,
    pipNumber: t.String,
    pipStatuses: PipStatuses,
    report: OpenPipProgramsReport,
    reportIsScrollable: ReportIsScrollable,
    selectedDealers: SelectedDealers,
    showNoResultsFound: t.Boolean
}, 'OpenPipReport');

export const getDefaultState = () =>
    new OpenPipReport({
        busyCounter: getBusyCounterDefaultState(),
        gridApi: getGridApiDefaultState(),
        includeFullyComplete: false,
        metric: getMetricDefaultState(),
        pipNumber: '',
        pipStatuses: getOpenPipProgramsStatusesDefaultState(),
        report: getOpenPipProgramsReportDefaultState(),
        reportIsScrollable: getReportIsScrollableDefaultState(),
        selectedDealers: getSelectedDealersDefaultState(),
        showNoResultsFound: false
    });

export default OpenPipReport;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/state/index.js